import { Link, createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { authApi } from "@/lib/api";
import { usePlatformConfig } from "@/lib/config";
import { useOnboardingStore } from "@/stores/onboarding";

export const Route = createFileRoute("/onboarding/signup")({
  head: () => ({
    meta: [{ title: "Create account" }],
  }),
  component: OnboardingSignupStep,
});

function OnboardingSignupStep() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { platformName, googleEnabled } = usePlatformConfig();
  const setStep = useOnboardingStore((s) => s.setStep);

  return (
    <div className="flex flex-1 flex-col">
      <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.18em] text-primary">
        {t("onboarding.signup.eyebrow")}
      </p>
      <h1 className="font-display text-3xl font-bold">
        {t("onboarding.signup.title", { name: platformName })}
      </h1>
      <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
        {t("onboarding.signup.body")}
      </p>

      <div className="mt-8 space-y-3">
        <Button
          className="w-full"
          onClick={() => {
            setStep("signup");
            void navigate({ to: "/signup" });
          }}
        >
          {t("common.signup")}
        </Button>
        <Button
          variant="outline"
          className="w-full"
          disabled={!googleEnabled}
          onClick={() => {
            window.location.href = authApi.googleStartUrl("user");
          }}
        >
          {t("common.googleContinue")}
        </Button>
        {!googleEnabled && (
          <p className="text-center text-xs text-muted-foreground">{t("common.googleDisabled")}</p>
        )}
        <Button
          variant="ghost"
          className="w-full"
          onClick={() => {
            setStep("verify");
            void navigate({ to: "/onboarding/verify" });
          }}
        >
          {t("onboarding.signup.useOtp")}
        </Button>
      </div>

      <p className="mt-auto pt-10 text-center text-xs text-muted-foreground">
        {t("onboarding.signup.haveAccount")}{" "}
        <Link to="/login" className="text-primary hover:underline">
          {t("common.login")}
        </Link>
      </p>
    </div>
  );
}
